import { useCallback, useEffect, useState } from 'react';
import type { DateKey } from '@/domain/date';
import type { Mark, PrayerId } from '@/domain/prayer';
import { emptyDay, type DayRecord } from '@/domain/streaks';
import { useAppState } from './useAppState';

export function useDayRecord(date: DateKey) {
  const { backend } = useAppState();
  const [day, setDay] = useState<DayRecord>(() => emptyDay(date));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    void (async () => {
      const loaded = await backend.records.day(date);
      if (cancelled) return;
      setDay(loaded);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [backend, date]);

  const setMark = useCallback(
    async (prayer: PrayerId, mark: Mark) => {
      await backend.records.setMark(date, prayer, mark);
      setDay(await backend.records.day(date));
    },
    [backend, date],
  );

  return { day, loading, setMark };
}
